import { CastorService } from '@aipb/gulliver/castor/data-access';
import { parseDetailCompositeKey } from '@aipb/gulliver/catalog/util';
import { ReportItemBody } from '@aipb/gulliver/report/model';
import { Component, Input, OnChanges } from '@angular/core';
import { BehaviorSubject, mergeMap } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'ip-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnChanges {
  @Input() id: string;
  @Input() castorUrl: string;
  @Input() coreId: string;

  reportDataItem: ReportItemBody;

  private _loading = new BehaviorSubject<boolean>(false);
  public loading$ = this._loading.asObservable();

  constructor(private castor: CastorService) {}

  ngOnChanges(): void {
    if (!this.id) return;

    this.castor.setCastorUrl(this.castorUrl);

    const s = parseDetailCompositeKey(this.id);
    const recordId = s[1];

    this._loading.next(true);
    this.castor
      .detailReportCore(this.coreId)
      .pipe(
        mergeMap((data) => {
          return this.castor.getRecordReport({
            reportId: data[0].reportId,
            coreId: this.coreId,
            recordId
          });
        }),
        finalize(() => {
          this._loading.next(false);
        })
      )
      .subscribe((data) => {
        this.reportDataItem = JSON.parse(data);
      });
  }
}
